import ActivityMentions from './ActivityMentions';

export default ActivityMentions;
